/* Keep Shopify's existing WELCOME10 eligibility and once-per-customer checks. */
(() => {
  'use strict';
  const code = 'WELCOME10';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let pending = false;
  let lastAttempt = '';
  let timer;

  function codesFrom(cart) {
    const codes = new Set();
    for (const entry of cart.discount_codes || []) {
      if (entry.code) codes.add(entry.code.toUpperCase());
    }
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      }
    }
    for (const application of applications) {
      if (application.type === 'discount_code' && application.title) {
        codes.add(application.title.toUpperCase());
      }
    }
    return codes;
  }

  async function applyWelcome() {
    if (busy) { pending = true; return; }
    busy = true;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.item_count) { lastAttempt = ''; return; }
      const codes = codesFrom(cart);
      if (codes.has(code)) return;
      // Keys change when discounts change; use variant/quantity instead to avoid loops.
      const signature = JSON.stringify([cart.items.map(item => [item.variant_id, item.quantity, item.properties, item.selling_plan_allocation?.selling_plan?.id]), [...codes].sort()]);
      if (signature === lastAttempt) return;
      lastAttempt = signature;
      codes.add(code);
      const updated = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: [...codes].join(',') })
      });
      if (!updated.ok) return;
      await updated.json();
      if (window.essentialCartApi?.refreshCart) await window.essentialCartApi.refreshCart();
    } catch (_) {
      // A network failure must never prevent adding products or checking out.
    } finally {
      busy = false;
      if (pending) { pending = false; schedule(); }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyWelcome, 150);
  }
  document.addEventListener('essential-cart:update', schedule);
  document.addEventListener('essential-cart:open', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  schedule();
})();
